import { FadeIn } from '../../components/AnimateIn'
import Button from '../../components/Button'
import Section from '../../components/Section'
import { Text } from '../../components/Text'

import BannerEllipse from './BannerEllipse'

export default function GoodNewsBanner() {
  return (
    <div className='z-0 flex w-full items-start'>
      <div className='relative flex w-full flex-shrink-0 overflow-clip bg-yellow-500 tracking-[0px] bg-opacity-70 backdrop-blur'>
        <div className='hidden lg:block'>
          <BannerEllipse variant='2' className='absolute h-[694px] w-[413px] flex-shrink-0' />
          <BannerEllipse
            variant='1'
            className='absolute right-[-160px] top-[-350px] h-[925px] w-[504px] flex-shrink-0'
          />
          <BannerEllipse
            variant='3'
            className='absolute right-[-160px] bottom-[-260px] h-[731px] w-[716px] flex-shrink-0'
          />
        </div>
        <Section className='flex flex-col gap-y-[44px] py-[64px] z-10'>
          <FadeIn delay={0.3}>
            <Text.H2 underline={'black'}>Good News</Text.H2>
          </FadeIn>
          <FadeIn delay={0.4}>
            <Text.Body>
              <p>
                The word “gospel” means “Good News,” and it represents the life-changing message of
                who Jesus Christ is, what He has done for us, and the profound impact that has on
                our lives. The gospel is the most important news you’ll ever hear, as it holds the
                power to transform everything—offering hope, salvation, and a new way of living
                through Jesus Christ.{' '}
              </p>
            </Text.Body>
          </FadeIn>
          <FadeIn delay={0.4} className='hidden lg:block'>
            <Text.Body>
              <p>
                Coming to faith in Jesus Christ involves a simple yet profound journey that begins
                with acknowledging our need for His grace, believing in His sacrifice, and choosing
                to follow Him fully. This journey can be understood in three steps: A – Admit that
                we have sinned and ask for God’s forgiveness. B – Believe in Jesus’ sacrifice on the
                cross and His resurrection. C – Confess and Choose to let God lead our lives. These
                steps lead to a transformative relationship with God, bringing forgiveness, purpose,
                and the assurance of eternal life.
              </p>
            </Text.Body>
          </FadeIn>
          <FadeIn delay={0.5} className='flex'>
            <Button variant='outline' href='/gospel' icon='ArrowRight' iconPosition='right'>
              Learn More
            </Button>
          </FadeIn>
        </Section>
      </div>
    </div>
  )
}
